<template>
  <div class="integralRecord">
    <van-nav-bar
      :title="title"
      left-arrow
      class="main-nav"
      @click-left="onClickLeft"
    />
    <div class="integralRecord_buttonBox">
      <div class="integralRecord_button" @click="goRule">积分规则</div>
    </div>
    <div class="integralRecord_listBox">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="integralRecord_listBox_list" v-for="(item, index) in list" :key="index">
          <div class="integralRecord_listBox_list_left">
            <div class="integralRecord_listBox_list_left_title">
              {{ item.name }}
            </div>
            <div class="integralRecord_listBox_list_left_time">
              {{ item.createTime }}
            </div>
          </div>
          <div class="integralRecord_listBox_list_right">
            <img src="@/assets/images/integral/money.png" />
            <p>X{{ item.score }}</p>
          </div>
        </div>
				<div class="noData" v-if="noDataStatus">
          <img
            class="_nodata_"
            src="@/assets/images/test-center/no-data.png"
            alt=""
          />
          <p class="_nodatap_">现在还没有数据哦！</p>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import { _getUserIntegral } from "../../api/integral";
import { verticalScreen } from "../../assets/js/vertical-screen";
export default {
  name: 'integral-record',
  data() {
    return {
      title: "积分记录",
			loading: true, //加载
      finished: false, // 结束加载
      page: 1, // 当前请求页码
      noDataStatus: false, //暂无数据状态
      list: [],//积分列表
			userId:'',
    };
  },
  mounted() {
		this.userId = this.$route.query.userId;
		this.getUserIntegral();
    verticalScreen();
  },
  methods: {
    // 返回
    onClickLeft() {
      this.$router.push("myIntegral");
    },
    // 获取积分列表
    getUserIntegral() {
      _getUserIntegral({
        "currentPage": this.page,
				"pageSize": 20,
				"queryData": {
        	userId: this.userId,
				},
      }).then((res) => {
        if (res && res.code == 200) {
          this.loading = false;
          let rows = res.data.list; //请求返回当页的列表
          if (rows.length < 20) {
            // 加载结束
            this.finished = true;
          }
          // 将新数据与老数据进行合并
          if (this.page == 1) {
            this.list = rows;
          } else {
            this.list = [
							...this.list,
							...rows
						];
          }
          if (this.list.length > 0) {
            this.noDataStatus = false;
          } else {
            this.noDataStatus = true;
          }
        } else {
          this.$toast(res.message);
          this.finished = true;
        }
      });
    },
		// 滑动加载
    onLoad() {
      this.page ++;
      this.getUserIntegral();
    },
    // 跳转查看积分规则页
    goRule() {
      this.$router.push("integralRule");
    },
  },
};
</script>
<style lang="scss" scoped>
.integralRecord {
  .integralRecord_buttonBox {
    display: flex;
    justify-content: flex-end;
    .integralRecord_button {
      width: 85px;
      height: 28px;
      background: linear-gradient(360deg, #ff7f30 0%, #ffbc97 100%);
      border-radius: 15px;
      color: #fff;
      text-align: center;
      line-height: 28px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      margin: 15px 15px 20px 0;
    }
  }
  .integralRecord_listBox {
    .integralRecord_listBox_list {
      width: 345px;
      height: 108px;
      background: #ffffff;
      box-shadow: 0px 3px 10px 0px rgba(214, 214, 214, 0.5);
      border-radius: 16px;
      margin-left: 15px;
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .integralRecord_listBox_list_left {
        margin-left: 24px;
        .integralRecord_listBox_list_left_title {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          margin-bottom: 6px;
        }
        .integralRecord_listBox_list_left_time {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }
      }
      .integralRecord_listBox_list_right {
        display: flex;
        margin-right: 20px;
        margin-top: 30px;
        img {
          width: 23px;
          height: 22px;
          margin-right: 3px;
        }
        p {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ff5151;
          line-height: 22px;
        }
      }
    }
  }
	.noData {
		padding: 30px;
		text-align: center;
	}
  ::v-deep .van-icon {
    color: #000;
  }
}
</style>
